import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const StyledLabel = styled.label`
  &.hide {
    font-size: 1rem;
    font-weight: normal;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 2.8125rem;
  border-radius: 0.25rem;
  border: 1px solid #d9d9d9;
  background: #fff;
  text-align: right;
  padding-right: 0.25rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 8.125rem;
  }
`;
